import { useMemo } from 'react'

import {
  createRouteClient,
  type portalRoutes,
  type publicBookingRoutes,
} from '@snootsvet/shared/portal'

import { env } from '@/customer/lib/env'

/**
 * Typed client for the member routes in `portalRoutes`, authed via the
 * better-auth session cookie. Signed-link flows use `usePublicBookingApi`.
 */
export function usePortalApi() {
  return useMemo(
    () =>
      createRouteClient<typeof portalRoutes>({
        baseUrl: `${env.VITE_API_URL}/portal`,
        credentials: 'include',
      }),
    []
  )
}

/**
 * Typed client for the signed-link routes in `publicBookingRoutes`, authed
 * with the booking token from the URL. Passing `null` sends no token, so
 * pages can mount the hook before the URL param has been read.
 */
export function usePublicBookingApi(token: string | null) {
  return useMemo(
    () =>
      createRouteClient<typeof publicBookingRoutes>({
        baseUrl: env.VITE_API_URL,
        headers: async (): Promise<Record<string, string>> =>
          token ? { Authorization: `Bearer ${token}` } : {},
      }),
    [token]
  )
}
